/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import {TableJoin} from './tableJoin';


export interface TableLiteDto {
    code?: string;
    description?: string;
    id?: string;
    label?: string;
    tableDependencies?: Array<TableJoin>;
    versioning?: boolean;
    ownerPartner?: string;
}
